export default __webpack_public_path__ + "static/media/guia_evaluacion_prequirurgica_cirugia.c31f2d59.pdf";